// Lucide icon: file-plus-corner (https://lucide.dev/icons/file-plus-corner)
import { FilePlusCorner } from 'lucide-react'

import { IconComponentStyled } from '../styles/IconComponentStyled'
import { type IIconComponentProps } from '../types'

export const IconRequest = (props: IIconComponentProps) => {
  return (
    <IconComponentStyled {...props}>
      <FilePlusCorner />
    </IconComponentStyled>
  )
}
